/**
 * @constructor
 * @param {GameConfig} cfg
 * @returns {ReelPrinter}
 */
export function ReelPrinter(cfg) {
	/** @type {GameConfig} */
	this._gameCfg = cfg;
};


/**
 * @param {SpinReel} reel
 */
ReelPrinter.prototype.print = function(reel) {

	for(var k = 0; k < reel.symbols.length; k++) {

		var i = reel.id;

		var pos = this._gameCfg.reelsPositions[i]["y"] + ((this._gameCfg.symbolHeight + this._gameCfg.symbolOffsetY) * k) + reel.shiftY;

		if(reel.symbols[k].locked) {
			return;
		}

		reel.symbols[k] && reel.symbols[k].setPosY(
			pos,
			true
		);
	}
};